import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer mt-4">
      <div className="footer-left">
        Copyright © {new Date().getFullYear()} <a href="https://www.totalbits.com/">TotalBits</a>. All rights reserved.
      </div>
      <div className="footer-right reverse">moc.stiblatot@ofni</div>
    </footer>
  );
}

export default Footer;
